import { useAmplitude, AmplitudeEvent } from "./useAmplitude";
import { applicationConfig } from "application/config/applicationConfig";

export const useSupport = () => {
  const { trackEvent } = useAmplitude();

  const openSupport = () => {
    trackEvent(AmplitudeEvent.Help_Button);
    window.open(applicationConfig.SUPPORT_URL, "_blank");
  };

  return {
    openSupport,
  };
};
